import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product sku.
 * This component listens for variant update events and updates the sku display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (product page)
 * 2. Swatches variant picker (in product cards if added to the product card)
 */


class VariantSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }
  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog')
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);

  }
  /**
    * Updates the sku.
    * @param {VariantUpdateEvent} event - The variant update event.
    */
  updateSku = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSku = event.detail.data.html.querySelector('variant-sku [ref="sku"]');
    const currentSku = this.querySelector('[ref="sku"]');

    if (!newSku || !currentSku) return;
    if (currentSku.innerHTML !== newSku.innerHTML) {
      currentSku.replaceWith(newSku);
    }
  }

}

if (!customElements.get('variant-sku')) {
  customElements.define('variant-sku', VariantSku);
}
